import { Component, OnInit, Input, SimpleChanges, OnChanges, EventEmitter, Output, Inject, OnDestroy, forwardRef } from '@angular/core';
import { FormGroup, FormControl, Validators} from '@angular/forms';

import { DatexFormControl } from './models/datex-form-control';
import { 
  TextBoxModel, 
  NumberBoxModel, 
  SelectBoxModel, 
  ESelectBoxType,
  DateBoxModel, 
  CheckBoxModel, 
  TextModel, 
  LabelModel, 
  ButtonModel,
  SplitButtonModel,
  SeparatorModel,
  ImageModel,
  DrawModel,
  CodeBoxModel,
  ButtonStyles 
} from './models/control';
import { GridHeaderModel, GridCellModel, GridRowModel, CellStyles, GridContainerStyle, HeaderStyles } from './models/grid'
import { FieldModel } from './models/field'
import { ToolModel } from './models/tool';
import { Styles, ControlContainerStyles } from './models/style';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { isEqual, isNil, set } from 'lodash-es';
import { GridComponent, ELoadingStatus } from './components/grid.component';
import { BaseComponent } from './components/base.component';
import { WorkBook, read as readExcelFile, writeFile as writeExcelFile, utils as excelUtils } from 'xlsx';

import { SharedModule } from './shared.module';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';
import { FootprintManager_ShellService } from './FootprintManager.shell.service';
import { FootprintManager_OperationService } from './FootprintManager.operation.service';
import { FootprintManager_DatasourceService } from './FootprintManager.datasource.index';
import { FootprintManager_FlowService } from './FootprintManager.flow.index';
import { FootprintManager_ReportService } from './FootprintManager.report.index';
import { FootprintManager_LocalizationService } from './FootprintManager.localization.service';
import { FootprintManager_billing_supplemental_fees_grid_ComponentContextService } from './FootprintManager.billing_supplemental_fees_grid.component.context.service';
import { Language } from './localization.service';
import { JobStatus } from './common-interfaces'
import { ApplicationType, ComponentType } from './app-context.service';
import { CleanupLoggerService } from './cleanup.logging.service';
import { $frontendTypes} from './FootprintManager.frontend.types'
import { $frontendTypes as $types} from './FootprintManager.frontend.types' 

import { EModalSize, EToasterType, EToasterPosition } from 'wavelength-ui';
import { Invoices_billingcodes_dd_singleComponent } from './Invoices.billingcodes_dd_single.component'


interface IFootprintManager_billing_supplemental_fees_gridComponentEntity {
  Id?: number, BillingCodeId?: number, BillingContractLineId?: number, Rate?: number, Value?: number, ValueIsPercentage?: boolean, BillingCode?: { Name?: string }}

interface IFootprintManager_billing_supplemental_fees_gridComponentInParams {
  billingContractLineId: number, edit: boolean}


class FootprintManager_billing_supplemental_fees_gridComponentRowModel extends GridRowModel {
  grid: FootprintManager_billing_supplemental_fees_gridComponent;
  entity: IFootprintManager_billing_supplemental_fees_gridComponentEntity;

  vars: { rateId?: number } = { };


 // temporarily put required on all edit controls
  override formGroup = new FormGroup({
    BillingCode_edit: new DatexFormControl(null, { validators: [ Validators.required ], updateOn: 'change' }),
    Rate_edit: new DatexFormControl(null, { validators: [ Validators.required ], updateOn: 'change' }),
    Value_edit: new DatexFormControl(null, { validators: [ Validators.required ], updateOn: 'change' }),
    PercentOfBillingCharge_display: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    PercentOfBillingCharge_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
  });

  override cells = {
    Id: null,
    BillingCode: null,
    Rate: null,
    Value: null,
    PercentOfBillingCharge: null,
  }



  constructor(
    grid: FootprintManager_billing_supplemental_fees_gridComponent,
    private $utils: UtilsService,
private $settings: SettingsValuesService,
private $shell: FootprintManager_ShellService,
private $datasources: FootprintManager_DatasourceService,
private $flows: FootprintManager_FlowService,
private $reports: FootprintManager_ReportService,
private $localization: FootprintManager_LocalizationService,
private $operations: FootprintManager_OperationService,
private $logger: CleanupLoggerService,
private $context: FootprintManager_billing_supplemental_fees_grid_ComponentContextService,
) {
    super();

    this.grid = grid;

    this.cells.Id = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.Id,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.BillingCode = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.BillingCode,
      new TextModel(null, null, null, null, null)
,
      new SelectBoxModel(
        this.formGroup.controls['BillingCode_edit'] as DatexFormControl, 
        ESelectBoxType.dropdown, null,
        false,
        false,
        '', null)
      );
    
    this.cells.Rate = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.Rate,
      new TextModel(null, null, null, null, null)
,
      new NumberBoxModel(this.formGroup.controls['Rate_edit'] as DatexFormControl, null, false, false, '0.0', '', null)
      );
    
    this.cells.Value = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.Value,
      new TextModel(null, null, null, null, null)
,
      new NumberBoxModel(this.formGroup.controls['Value_edit'] as DatexFormControl, null, false, false, '0.0', '', null)
      );
    
    this.cells.PercentOfBillingCharge = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.PercentOfBillingCharge,
      new CheckBoxModel(this.formGroup.controls['PercentOfBillingCharge_display'] as DatexFormControl, null, false, false, '', null)
,
      new CheckBoxModel(this.formGroup.controls['PercentOfBillingCharge_edit'] as DatexFormControl, null, false, false, '', null)
      );
    
    
  }

  async $initializeExisting(entity: IFootprintManager_billing_supplemental_fees_gridComponentEntity) {
    this.entity = entity;

    this.rowId = [this.entity.Id].join('-');

    await this.$dataLoaded();
  }

  async $initializeNew(entity?: IFootprintManager_billing_supplemental_fees_gridComponentEntity) {
    this.isNew = true;

    if (entity) {
      this.entity = entity;
    }
    else {
      this.entity = {};
    }

    this.rowId = [this.entity.Id].join('-');
    await this.$dataLoaded();
    // mark the whole form as dirty, since this is a new row 
    // and even if it is valid, it should have a changed state
    this.formGroup.markAsDirty();
  }

  private $unsubscribe$ = new Subject();
  override destroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();
  }

  $init() {
  }

  async $dataLoad() {
    const $row = this;
    const $grid = this.grid;
    const $utils = this.$utils;
    const $resultKey = this.entity.Id;
    const inParams = {
      $keys:[$resultKey],
      billingContractLineId:  $grid.inParams.billingContractLineId ,
      billingContractId:  null ,
    };
    const data = await this.$datasources.Invoices.ds_billing_supplemental_fees_grid.getByKeys(inParams);
    
    await this.grid.$applyLinkedDatasourcesAndCustomColumns(inParams, data);
      
    this.entity = data.result[0] as IFootprintManager_billing_supplemental_fees_gridComponentEntity;
    await this.$dataLoaded();
  }

  async $dataLoaded() {
    const $row = this;
    const $grid = this.grid;
    const $utils = this.$utils;
    (this.cells.Id.displayControl as TextModel).text = $row.entity.Id?.toString();
    (this.cells.BillingCode.displayControl as TextModel).text = $row.entity.BillingCode?.Name;
    (this.cells.BillingCode.editControl as SelectBoxModel).reset($row.entity.BillingCodeId);
    (this.cells.Rate.displayControl as TextModel).text = $row.entity.Rate?.toString();
    (this.cells.Rate.editControl as NumberBoxModel).reset($row.entity.Rate);
    (this.cells.Value.displayControl as TextModel).text = $row.entity.Value?.toString();
    (this.cells.Value.editControl as NumberBoxModel).reset($row.entity.Value);
    (this.cells.PercentOfBillingCharge.displayControl as CheckBoxModel).reset($row.entity.ValueIsPercentage);
    (this.cells.PercentOfBillingCharge.editControl as CheckBoxModel).reset($row.entity.ValueIsPercentage);

    await this.on_data_loaded();
  }

  override async refresh() {
    if (this.grid.$hasMissingRequiredInParams) {
      return Promise.resolve(null);
    }
    await this.$dataLoad();
    // grid refresh skipSelf=true, skipParent=false, skipChildren=false  
    this.grid.$refreshEvent.emit();
  }

  override async save() {
    if (this.isNew) {
      await this.on_save_existing_row();
      this.isNew = false;
    } else {
      await this.on_save_existing_row();
    } 
  }

  override $cellClicked(cellId: string) {
    super.$cellClicked(cellId);
    switch(cellId) {
    }
  }

  //#region private flows
  on_data_loaded(event = null) {
    return this.on_data_loadedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_data_loadedInternal(
    $row: FootprintManager_billing_supplemental_fees_gridComponentRowModel,
  $grid: FootprintManager_billing_supplemental_fees_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_billing_supplemental_fees_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  //O.Arias 07/20/2023
  
  //Setting the rate id on a variable so we can work with the tab and new row
  $row.vars.rateId = $row.entity.Id;
  
  }
  on_init(event = null) {
    return this.on_initInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_initInternal(
    $row: FootprintManager_billing_supplemental_fees_gridComponentRowModel,
  $grid: FootprintManager_billing_supplemental_fees_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_billing_supplemental_fees_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  //O.Arias - 07/20/2023
  
  //Check if the editor was opened in edit mode
  if ($grid.inParams.edit) {
  
      $grid.canEdit = true;
  
  
  } else {
  
      $grid.canEdit = false;
  
  };
  }
  on_save_existing_row(event = null) {
    return this.on_save_existing_rowInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_save_existing_rowInternal(
    $row: FootprintManager_billing_supplemental_fees_gridComponentRowModel,
  $grid: FootprintManager_billing_supplemental_fees_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_billing_supplemental_fees_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  //O.Arias - 09/27/2023
  
  try {
  
      if (!$utils.isAllDefined($row.cells.BillingCode, $row.cells.Rate, $row.cells.Value, $row.cells.PercentOfBillingCharge)) {
          await $shell.FootprintManager.openErrorDialog('Line cannot be saved', 'Please fill in all required fields.');
          $grid.refresh();
          return;
      } else {
  
          if (!$utils.isDefined($row.cells.PercentOfBillingCharge)) {
              $row.cells.PercentOfBillingCharge.editControl.value = false;
          };
  
          $row.cells.BillingCode.displayControl.text = $row.cells.BillingCode.editControl.displayText;
          $row.cells.Rate.displayControl.text = $row.cells.Rate.editControl.value;
          $row.cells.Value.displayControl.text = $row.cells.Value.editControl.value;
          $row.cells.PercentOfBillingCharge.displayControl.value = $row.cells.PercentOfBillingCharge.editControl.value ? $row.cells.PercentOfBillingCharge.editControl.value : false;
  
          let rate = $row.cells.Rate.editControl.value;
          let value = $row.cells.Value.editControl.value;
          let percent = $row.cells.PercentOfBillingCharge.editControl.value ? $row.cells.PercentOfBillingCharge.editControl.value : false;
          let billing_code_id = $row.cells.BillingCode.editControl.value;
  
          let line_id = $row.entity?.Id ? $row.entity.Id : -1;
  
          if (line_id > 0) {
              //Update
              const payload = {
                  "Id": line_id,
                  "BillingContractLineId": $grid.inParams.billingContractLineId,
                  "BillingCodeId": billing_code_id,
                  "Rate": rate,
                  "Value": value,
                  "ValueIsPercentage": percent
              };
  
              await $flows.Utilities.crud_update_flow({ entitySet: 'BillingSupplementalFees', entity: payload, id: line_id });
  
          } else {
              //Insert
              const payload = {
                  "BillingContractLineId": $grid.inParams.billingContractLineId,
                  "BillingCodeId": billing_code_id,
                  "Rate": rate,
                  "Value": value,
                  "ValueIsPercentage": percent
              };
  
              await $flows.Utilities.crud_create_flow({ entitySet: 'BillingSupplementalFees', entity: payload });
          };
  
          //$grid.refresh();
  
      };
  
  } catch (error) {
      const errorMessage = $utils.isDefined(error?.error?.error) ? error?.error?.error.message : error;
      const errorDetail = $utils.isDefined(error?.error?.error) ? error?.error?.error : error;
      const errorDescription = `Line Id ${$grid.inParams.billingContractLineId} - ${errorMessage}`;
      await $shell.FootprintManager.openErrorDialog('Error saving the line', 'An error occurred during saving of the line.', [errorDescription], null, [{ message: errorDescription, detail: errorDetail }]);
      $grid.refresh();
  };
  }
  //#endregion private flows

}


@Component({
  standalone: true,
  imports: [
    SharedModule,
    forwardRef(() => Invoices_billingcodes_dd_singleComponent),
  ],
  selector: 'FootprintManager-billing_supplemental_fees_grid',
  templateUrl: './FootprintManager.billing_supplemental_fees_grid.component.html'
})
export class FootprintManager_billing_supplemental_fees_gridComponent extends BaseComponent implements OnInit, OnChanges, OnDestroy {
  //#region Outputs
  @Output()
  $finish = new EventEmitter();
  @Output()
  $refreshEvent = new EventEmitter();
  //#endregion Outputs

  entities: IFootprintManager_billing_supplemental_fees_gridComponentEntity[];

  pageSize = 10;
  pageSkip = 0;
  totalCount = 0;
  loadingStatus = ELoadingStatus.Loading;

canEdit: boolean = true;
// to stop add from flow
// canAdd = false; //hide add button, check on exitFromLastCell 
// bottomToolbar.addLine.hidden = true; //hide add button, no check on exitFromLastCell 
// bottomToolbar.addLine.control.readOnly = true; //disable add button, check on exitFromLastCell 
canAdd: boolean = true; 
  
  containerStyles: GridContainerStyle = new GridContainerStyle('cellsWidth', ['fit-content-table']);


  inParams: IFootprintManager_billing_supplemental_fees_gridComponentInParams = { billingContractLineId: null, edit: null };


  //#region Variables
  //#endregion
  //#region Events
  
  //#endregion

  headers = {
     Id: new GridHeaderModel(new HeaderStyles(null, null), 'Id', 'Id', false, false, null, false),       BillingCode: new GridHeaderModel(new HeaderStyles(null, null), 'BillingCode', 'Billing code', true, false, null, false),       Rate: new GridHeaderModel(new HeaderStyles(null, null), 'Rate', 'Rate', true, false, null, false),       Value: new GridHeaderModel(new HeaderStyles(null, null), 'Value', 'Value', true, false, null, false),       PercentOfBillingCharge: new GridHeaderModel(new HeaderStyles(null, null), 'PercentOfBillingCharge', '% of billing charge', false, false, null, false),  
  };

  //#region title
  // Make it async so that it won't cause expressionChangedAfterItHasBeenCheckedError
  // The title is often meant to be shown from the parent (shell breadcrumb for example)
  // and often it will cause an expressionChangedAfterItHasBeenCheckedError because 
  // the parent has already been checked and the child now change something on the parent 
  // in dev, CD is run twice
  $titleChange = new EventEmitter<string>(true);
  private $_title: string;
  get title(): string {
    return this.$_title;
  }
  set title(t: string) {
    this.$_title = t;
    this.$titleChange.emit(this.$_title);
  }
  //#endregion title
  rows: FootprintManager_billing_supplemental_fees_gridComponentRowModel[] = [];

  @Input('billingContractLineId') set $inParams_billingContractLineId(value: any) {
    this.inParams['billingContractLineId'] = value;
  }
  get $inParams_billingContractLineId(): any {
    return this.inParams['billingContractLineId'] ;
  }
  @Input('edit') set $inParams_edit(value: any) {
    this.inParams['edit'] = value;
  }
  get $inParams_edit(): any {
    return this.inParams['edit'] ;
  }

  topToolbar = {
      deleteLine: new ToolModel(new ButtonModel('deleteLine', new ButtonStyles(['destructive'], null), false, false, false, 'Delete', 'icon-ic_fluent_delete_20_regular', null)
    , false)
  };

  bottomToolbar = {
    addLine : new ToolModel(new ButtonModel(null, null, false, false, false, 'Add row', 'icon-ic_fluent_add_circle_20_regular')),
  };




  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    private $shell: FootprintManager_ShellService,
    private $datasources: FootprintManager_DatasourceService,
    private $flows: FootprintManager_FlowService,
    private $reports: FootprintManager_ReportService,
    private $localization: FootprintManager_LocalizationService,
    private $operations: FootprintManager_OperationService,
    private $logger: CleanupLoggerService,
    private $context: FootprintManager_billing_supplemental_fees_grid_ComponentContextService,
    ) {
    super();
    this.title = 'Billing supplemental fees grid';
    this.$subscribeFormControlValueChanges();
  }

  ngOnInit(): void {
    this.$checkRequiredInParams();
    if (!this.$hasMissingRequiredInParams) {
      this.$init();
    } else {
      this.$initEmpty();
    }
  }
  
  private $isFirstNgOnChanges = true;
  ngOnChanges(changes: SimpleChanges): void {
    if (this.$isFirstNgOnChanges) {
      this.$isFirstNgOnChanges = false;
    } else {
      this.$checkRequiredInParams();
      if(!this.$hasMissingRequiredInParams) {
        this.$init();
      } else {
        this.$initEmpty();
      }
    }
  }

  $missingRequiredInParams = [];
  get $hasMissingRequiredInParams(): boolean {
    return !!this.$missingRequiredInParams.length;
  }
  
  $checkRequiredInParams() {
    this.$missingRequiredInParams = [];
      if(isNil(this.inParams.billingContractLineId)) {
        this.$missingRequiredInParams.push('billingContractLineId');
      }
      if(isNil(this.inParams.edit)) {
        this.$missingRequiredInParams.push('edit');
      }
  }

  initialized = false;

  private $unsubscribe$ = new Subject();
  ngOnDestroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();

    this.clearRows();
  }

  async $init() {
    const $grid = this;
    const $utils = this.$utils;

    this.pageSize = 25;


    await this.on_init();
    this.initialized = true;

    this.pageSkip = 0;
    this.refresh(true, true, null);
  }

  protected override $initEmpty() {
    this.clearRows();
  }

  private $subscribeFormControlValueChanges() {

  }

  reload() {
    this.pageSkip = 0;
    this.refresh();
  }

  refresh(
    skipParent = false,
    skipChildren = false,
    childToSkip: string = null) {
    if (this.$hasMissingRequiredInParams) {
      return Promise.resolve(null);
    }
    // up
    if (skipParent === false) {
      this.$refreshEvent.emit();
    }

    // self
    const result = this.$dataLoad();

    // children
    if (skipChildren === false) {
    }

    return result;
  }

  async $dataLoad() {
    this.loadingStatus = ELoadingStatus.Loading;
    const $grid = this;
    const $utils = this.$utils;
    const inParams = {
      $top: this.pageSize,
      $skip: this.pageSkip,
      billingContractLineId:  $grid.inParams.billingContractLineId ,
      billingContractId:  null ,
    };
    try {
      const data = await this.$datasources.Invoices.ds_billing_supplemental_fees_grid.getList(inParams);
      
      await this.$applyLinkedDatasourcesAndCustomColumns(inParams, data);

      this.entities = data.result as IFootprintManager_billing_supplemental_fees_gridComponentEntity[];
      this.totalCount = data.totalCount;

      await this.$dataLoaded();
      if (this.totalCount === 0) {
        this.loadingStatus = ELoadingStatus.NoResults;
      } else {
        this.loadingStatus = ELoadingStatus.Loaded;
      }
    } catch(error) {
      console.error("Error loading data:", error);
      this.loadingStatus = ELoadingStatus.Error;
    }
  }

  async $dataLoaded() {
    const $grid = this;
    const $utils = this.$utils;
    
    this.clearRows();

    if(this.entities) {
      let rowLoadPromises = [];
      for (let entity of this.entities) {
        const row = new FootprintManager_billing_supplemental_fees_gridComponentRowModel(
          this,
          this.$utils,
          this.$settings,
          this.$shell, 
          this.$datasources,
          this.$flows,
          this.$reports,
          this.$localization,
          this.$operations,
          this.$logger,
          this.$context);
        rowLoadPromises.push(row.$initializeExisting(entity));
        this.rows.push(row);
      }
      await Promise.all(rowLoadPromises);
    }

    await this.on_data_loaded();
  }

  
    async $applyLinkedDatasourcesAndCustomColumns(inParams: any, outParams: any) {
      const $datasource = { inParams: inParams };
      const $utils = this.$utils;
  
    }

  clearRows() {
    if(this.rows && this.rows.length) {
      this.rows.forEach(r => r.destroy());
    }
    this.rows = [];
  }

  selectedRows: FootprintManager_billing_supplemental_fees_gridComponentRowModel[] = [];
  hasSelectedRows() {
    return this.selectedRows.length > 0;
  }

  async $selectionChanged(selectedRows: any[]) {
    this.selectedRows = selectedRows;
    await this.on_select();
  }

  async addRow(entity?: IFootprintManager_billing_supplemental_fees_gridComponentEntity) {
    const row = new FootprintManager_billing_supplemental_fees_gridComponentRowModel(
      this,
      this.$utils,
      this.$settings,
      this.$shell, 
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$localization,
      this.$operations,
      this.$logger,
      this.$context);
    await row.$initializeNew(entity);
    this.rows.push(row);
    row.setEditMode();
    return row;
  }
  
  openImageViewer(imageSource: string) {
    this.$shell.openImageViewerDialog(imageSource);
  }

  //#region private flows
  on_delete(event = null) {
    return this.on_deleteInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_deleteInternal(
    $grid: FootprintManager_billing_supplemental_fees_gridComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_billing_supplemental_fees_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  //O.Arias - 09/27/2023
  
  const lines = $grid.selectedRows;
  
  if (lines.length === 0) {
  
      $shell.FootprintManager.openErrorDialog('Delete lines errors', 'No lines were selected.');
      return;
  
  } else {
  
      const delete_success = [];
      const delete_failures = [];
      const errorMsgList = [];
      const errorMsgListDetails = [];
  
      for (let line of lines) {
  
          try {
  
              await $flows.Utilities.crud_delete_flow({ entitySet: "BillingSupplementalFees", id: line.entity.Id })
              delete_success.push(line);
  
          } catch (error) {
  
              delete_failures.push(line);
              const errorMessage = $utils.isDefined(error?.error?.error) ? error?.error?.error.message : error;
              const errorDetail = $utils.isDefined(error?.error?.error) ? error?.error?.error : error;
              const errorDescription = `lines ${line.entity.Id.toString()} - ${errorMessage}`;
              errorMsgList.push(errorDescription);
              errorMsgListDetails.push({ message: errorDescription, detail: errorDetail });
          }
      }
  
      // all succeeded
      if (delete_success.length === lines.length) {
  
          const title = 'All line(s) deleted';
          const message = `line(s) ${delete_success.map(c => c.entity.Id.toString()).join(',')} deleted`;
          await $shell.FootprintManager.openInfoDialog(title, message);
          await $grid.refresh();
  
      } else {
  
          // all failures
          if (delete_failures.length === lines.length) {
  
              const title = 'All line(s) failed to delete';
              const message = `line(s) ${delete_failures.map(c => c.entity.Id.toString()).join(',')} could not be deleted`;
              await $shell.FootprintManager.openErrorDialog(title, message, errorMsgList, null, errorMsgListDetails);
  
          } else {
  
              const title = 'Some lines could not be deleted';
              const success = `line(s) ${delete_success.map(c => c.entity.Id.toString()).join(',')} were deleted.`;
              const errors = `The following line(s) could not be deleted: ${delete_failures.map(c => c.entity.Id.toString()).join(',')}`;
              const message = `${success} \r\n\r\n${errors}`;
              await $shell.FootprintManager.openErrorDialog(title, message, errorMsgList, null, errorMsgListDetails);
              await $grid.refresh();
  
          }
      }
  }
  
  }
  on_init(event = null) {
    return this.on_initInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_initInternal(
    $grid: FootprintManager_billing_supplemental_fees_gridComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_billing_supplemental_fees_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  //O.Arias - 07/21/2023
  
  //Start as read only
  $grid.topToolbar.deleteLine.control.readOnly = true;
  //$grid.topToolbar.deleteLine.hidden = true;
  
  //If we get the edit parameter
  if ($grid.inParams.edit) {
  
      $grid.bottomToolbar.addLine.control.readOnly = false;
      $grid.bottomToolbar.addLine.hidden = false;
      $grid.canEdit = true;
      $grid.headers.BillingCode.required = true;   
      $grid.headers.Rate.required = true;
      $grid.headers.Value.required = true;
      $grid.headers.PercentOfBillingCharge.required = true;
      
  } else {
  
      $grid.bottomToolbar.addLine.control.readOnly = true;
      $grid.bottomToolbar.addLine.hidden = true;
      $grid.canEdit = false;
      $grid.headers.BillingCode.required = false;
      $grid.headers.Rate.required = false;
      $grid.headers.Value.required = false;
      $grid.headers.PercentOfBillingCharge.required = false;
      
  }
  }
  on_data_loaded(event = null) {
    return this.on_data_loadedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_data_loadedInternal(
    $grid: FootprintManager_billing_supplemental_fees_gridComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_billing_supplemental_fees_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  //O.Arias - 09/27/2023
  
  //Start as read only
  $grid.topToolbar.deleteLine.control.readOnly = true;
  //$grid.topToolbar.deleteLine.hidden = true;
  
  //If we get the edit parameter
  if ($grid.inParams.edit) {
      $grid.bottomToolbar.addLine.control.readOnly = false;
      $grid.bottomToolbar.addLine.hidden = false;
      $grid.canEdit = true;
      $grid.headers.BillingCode.required = true;
      $grid.headers.Rate.required = true;
      $grid.headers.Value.required = true;
      $grid.headers.PercentOfBillingCharge.required = true;
  } else {
      $grid.bottomToolbar.addLine.control.readOnly = true;
      $grid.bottomToolbar.addLine.hidden = true;
      $grid.canEdit = false;
      $grid.headers.BillingCode.required = false;
      $grid.headers.Rate.required = false;
      $grid.headers.Value.required = false;
      $grid.headers.PercentOfBillingCharge.required = false;
  }
  }
  on_select(event = null) {
    return this.on_selectInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_selectInternal(
    $grid: FootprintManager_billing_supplemental_fees_gridComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_billing_supplemental_fees_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  //O.Arias - 07/21/2023
  
  //If we get the edit parameter
  if ($grid.inParams.edit) {
      if ($grid.selectedRows.length === 0) {
          $grid.topToolbar.deleteLine.control.readOnly = true;
          //$grid.topToolbar.deleteLine.hidden = true;
      } else {
          $grid.topToolbar.deleteLine.control.readOnly = false;
          //$grid.topToolbar.deleteLine.hidden = false;
      };
  } else {
      $grid.topToolbar.deleteLine.control.readOnly = true;
      //$grid.topToolbar.deleteLine.hidden = true;
  };
  }
  //#endregion private flows


 
  close() {
    this.$finish.emit();
  }
}
